import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_CAMPAIGN = {
  'loading': false,
  'partsArray': [],
  'loadingPart': false,
  'part': {},
};

const updatePartsArrayMinStock = (partsArray, updateElement) => {
  const {index, value} = updateElement;
  const newParts = [...partsArray];
  const newObj = Object.assign({}, newParts[index], {'minStock': value < 0 ? 0 : value});
  newParts[index] = newObj;
  return newParts;
};

export const campaignParts = (state, action) => {
  return createReducer(INITIAL_STATE_CAMPAIGN, {
    [ActionTypes.FETCHING_CAMPAIGN_BY_ID]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_BY_ID]: (state, action) => {
      const {partsArray} = action.response.data;
      return {
        ...state,
        'loading': false,
        'partsArray': partsArray || [],
      };
    },
    [ActionTypes.FETCHED_CAMPAIGN_BY_ID_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'partsArray': [],
    }),
    [ActionTypes.FETCHING_PARTS_BY_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PARTS_BY_CAMPAIGN]: (state, action) => {
      const {partsArray} = action.response.data;
      return {
        ...state,
        'loading': false,
        'partsArray': partsArray,
      };
    },
    [ActionTypes.FETCHED_CAMPAIGN_PART_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'partsArray': [],
    }),
    [ActionTypes.ADDED_CAMPAIGN]: (state, action) => ({
      ...state,
      'partsArray': [],
    }),
    [ActionTypes.ADDED_CAMPAIGN_FAILED]: (state, action) => ({
      ...state,
      'partsArray': [],
      'part': {},
    }),
    [ActionTypes.UPDATING_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': false,
      'partsArray': action.response.data.partsArray,
    }),
    [ActionTypes.UPDATED_CAMPAIGN_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CLEAR_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': false,
      'partsArray': [],
      'loadingPart': false,
      'part': {},
    }),
    [ActionTypes.PROCESSING_CAMPAIGN_CHASSIS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.PROCESSED_CAMPAIGN_CHASSIS]: (state, action) => {
      const {partsArray} = action.response.data;
      return {
        ...state,
        'loading': false,
        'partsArray': partsArray,
      };
    },
    [ActionTypes.PROCESSED_CAMPAIGN_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'partsArray': [],
    }),
    [ActionTypes.CHANGE_PARTS_MIN_STOCK]: (state, action) => ({
      ...state,
      'partsArray': updatePartsArrayMinStock(state.partsArray, action.payload),
    }),
    [ActionTypes.FETCHING_CAMPAIGN_PART]: (state, action) => ({
      ...state,
      'loadingPart': true,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_PART]: (state, action) => ({
      ...state,
      'loadingPart': false,
      'part': action.response.data,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_PART_FAILED]: (state, action) => ({
      ...state,
      'loadingPart': false,
      'part': {},
    }),
    [ActionTypes.ADDING_ELEMENT_FOR_CAMPAIGN_PARTS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_ELEMENT_FOR_CAMPAIGN_PARTS]: (state, action) => ({
      ...state,
      'loading': false,
      'partsArray': action.response.data.partsArray,
      'part': {},
    }),
    [ActionTypes.ADDED_ELEMENT_FOR_CAMPAIGN_PARTS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.REMOVING_ELEMENT_FOR_CAMPAIGN_PARTS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_PARTS]: (state, action) => ({
      ...state,
      'loading': false,
      'partsArray': action.response.data.partsArray,
    }),
    [ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_PARTS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
